<template>
    <div>
        <base-dropdown v-if="actions.length > 0" class="btn-block mb-2">
            <base-button slot="title" type="secondary" class="dropdown-toggle  btn-block" size="lg" icon="fas fa-tasks text-blue">
                Spielerschutzmaßnahme
            </base-button>
            <a v-for="action in actions" class="dropdown-item" href="#" :class="(action.isSetAuto) ? 'is-set-auto' : ''" :key="action.id" v-on:click.prevent="openActivityForm(action)">({{action.id}}) {{action.name}}{{(action.isSetAuto) ? '*' : ''}}</a>
            <div class="dropdown-divider"></div>
            <a v-for="action in actionsExpanded" class="dropdown-item" href="#" :class="(action.isSetAuto) ? 'is-set-auto' : ''" :key="action.id" v-on:click.prevent="openActivityForm(action)">({{action.id}}) {{action.name}}{{(action.isSetAuto) ? '*' : ''}}</a>
            <div class="text-sm-center dropdown-info dropdown-item">* werden automatisch angelegt</div>
        </base-dropdown>
        <modal :show.sync="modals.confirmation">
            <h6 slot="header" class="modal-title" id="modal-title-default">Spielerschutzmaßnahme anlegen</h6>

            <p class="lead">
                <b>{{data.action.name}}</b>
            </p>


            <textarea :disabled="isLoading" v-model="data.comment" class="form-control form-control-alternative" rows="3" placeholder="Zusätzliche Informationen bitte hier angeben"></textarea>

            <small class="text-muted">Möchten Sie die Spielerschutzmaßnahme mit dem Profil "{{activeProfile.name}}" anlegen?
                <base-button icon="ni ni-circle-08" type="secondary" :disabled="isLoading" @click="$store.dispatch('profiles/setNoActiveProfile')" size="sm">Profil wechseln</base-button></small>

            <template slot="footer">
                <base-button type="primary" @click="createActivityAndClose" :disabled="isLoading" :icon="(isLoading) ? 'fas fa-circle-notch fa-spin' : 'fa fa-paper-plane'">Spielerschutzmaßnahme anlegen</base-button>
                <base-button type="link" class="ml-auto" @click="modals.confirmation = false">Schließen
                </base-button>
            </template>
        </modal>
    </div>
</template>

<script>
    export default {
        name:"Activity",
        props: {
          socialconcept: null
        },
        data() {
            return {
                modals: {confirmation: false},
                data: {
                    action: {id: 0, name: ""},
                    comment: ""
                },
                isLoading: false,
                response: {}
            }
        },
        created() {
            if (!this.$store.getters['actions/isLoading']) this.$store.dispatch('actions/getActionCollection');
        },
        computed: {
            activeProfile() {
                return (this.$store.getters['profiles/showActiveProfile'] !== null) ? this.$store.getters['profiles/showActiveProfile'] : {name: 'Bitte wählen'};
            },
            actions() {
                return (!this.$store.getters['actions/isLoading']) ? this.$store.getters['actions/showActionCollectionByConceptAndType'](this.socialconcept,false) : [{id:0,name: 'placeholder'}];
            },
            actionsExpanded() {
                return (!this.$store.getters['actions/isLoading']) ? this.$store.getters['actions/showActionCollectionByConceptAndType'](this.socialconcept,true) : [{id:0,name: 'placeholder'}];
            }
        },
        methods: {
            getActions(){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/actions?pagination=false`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            },
            openActivityForm(actionobj){
                this.data.action = actionobj;
                this.modals.confirmation = true;
            },
            addActivity() {
                return new Promise((resolve, reject) => {
                    if (this.$store.getters['profiles/showActiveProfile'] !== null ) {
                        const header = this.authHeader();
                        header['Content-Type'] = 'application/json';
                        let senddata = JSON.parse(JSON.stringify(this.data));
                        senddata.profile = this.$store.getters['profiles/showActiveProfile']['@id'];
                        senddata.location = 'api/locations/'+this.$store.getters['authentication/location'];
                        senddata.action = this.data.action['@id'];
                        const requestOptions = {
                            method: 'POST',
                            headers: header,
                            body: JSON.stringify(senddata)
                        };
                        fetch(process.env.VUE_APP_API_SERVER + `/api/activities`, requestOptions)
                            .then(this.handleResponse)
                            .then(response => {
                                    resolve(response);
                                },
                                error => {
                                    reject(error);
                                });
                    } else {
                        reject('Kein Profil ausgewählt!')
                    }
                });
            },
            createActivityAndClose() {
                // create Inspection Tour
                if (this.modals.confirmation) {
                    this.isLoading = true;
                    this.addActivity().then(response => {
                        this.data = {
                            action: {id: 0, name: ""},
                            comment: ""
                        };
                        this.response = response;
                        this.isLoading = false;
                        this.modals.confirmation = false;
                        this.$store.dispatch('alert/clear');
                        this.$store.dispatch('alert/success', 'Spielerschutzmaßnahme erfolgreich angelegt');
                    }).catch(error => {
                        this.$store.dispatch('alert/error', error);
                        this.isLoading = false;
                    });
                }
            },
        }
    }
</script>

<style scoped>

    .is-set-auto {
        color: #4d4d4d;
        font-style: italic;
    }

    .dropdown-info {
        font-size: 0.5rem;
    }

</style>